import type { OKTA_ENV } from 'features/auth/components/OktaRouter';

export default {
  API_URL: process.env.REACT_APP_API_URL ?? '',
  API_TIMEOUT: Number(process.env.REACT_APP_API_TIMEOUT ?? 0),
  OKTA_ISSUER: process.env.REACT_APP_OKTA_ISSUER ?? '',
  OKTA_CLIENT_ID: process.env.REACT_APP_OKTA_CLIENT_ID ?? '',
  OKTA_REDIRECT_URI: process.env.REACT_APP_OKTA_REDIRECT_URI ?? '',
  OKTA_ENV: (process.env.REACT_APP_OKTA_ENV ?? '') as OKTA_ENV,
  ALLESSEH_PREVIEW_URL: process.env.REACT_APP_ALLESSEH_PREVIEW_URL ?? '',
  ALLESSEH_ADMIN_TOOL: process.env.REACT_APP_ALLESSEH_ADMIN_TOOL ?? '',
  ALLESSEH_API_COLLECTION_SUMMARIES_URL: process.env.REACT_APP_ALLESSEH_API_COLLECTION_SUMMARIES_URL ?? '',
  UCS_COLLECTION_PREFIX: (process.env.REACT_APP_OKTA_ENV ?? '') === 'prd' ? 'UCSP' : 'UCSD',
  NARRATOR_TOOL: process.env.REACT_APP_NARRATOR_TOOL ?? ''
};
